import React, { Component } from 'react'

import { Button, Row, Col } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Moment from 'moment'
import PropTypes from 'prop-types'

import featureFlags from '../../utils/featureFlags'
import { Loading } from '../../components/shared'
 
const formatDateData = cell => Moment(cell).format('MMM Do YYYY<br />h:mma')

class ClearedSubmissionListTable extends Component {
    constructor(props) {
        super(props)
    }

    getPreClearedSubmission(cell, submission, rowIndex) {
        this.props.getQuotePreClearedSubmission(submission)
    }

    formatQuoteClearedSubmissionData = (cell, submission, enumObject, rowIndex) => {
        return (
            <Button onClick={() => this.getPreClearedSubmission(cell, submission, rowIndex)}>
                Get a Quote
            </Button>
        )
    }
    render() {
        const { isUnderwriter, data, loading } = this.props

        if (!featureFlags.getFeatureFlags().CLEARED_SUBMISSIONS_TABLE) return null
        if (!isUnderwriter) return null

        const tableOptions = {
            sizePerPage: 5,
            hideSizePerPage: true,
            defaultSortName: 'receivedDate',
            defaultSortOrder: 'desc',
        }

        return (
            <div className="submissions-list"  id ="preClearedSubmissions">
                <div className="submissions-list-table">
                    <h1>Pre-Cleared Submissions</h1>
                    <Row>
                        <Col xs={12} className="button-column">
                            { loading && <Loading width="22px" height="22px" /> }
                        </Col>
                    </Row>
                    <div className="submissions-table">
                        <BootstrapTable
                            data={data}
                            options={tableOptions}
                            hover
                            bordered
                            condensed
                            striped
                            pagination
                        >
                            <TableHeaderColumn isKey dataField="edgeSubmissionId" headerAlign="left" dataAlign="center" width="120px">Submission No.</TableHeaderColumn>
                            <TableHeaderColumn dataField="agencyName">Agency Name</TableHeaderColumn>
                            <TableHeaderColumn dataField="primaryInsuredName">Named Insured</TableHeaderColumn>
                            <TableHeaderColumn dataField="product" headerAlign="left" dataAlign="center" width="85px">Product</TableHeaderColumn>
                            <TableHeaderColumn dataField="status" headerAlign="left" dataAlign="center" width="120px">Status</TableHeaderColumn>
                            <TableHeaderColumn dataField="receivedDate" dataFormat={formatDateData} headerAlign="left" dataAlign="center" width="120px">Received</TableHeaderColumn>
                            <TableHeaderColumn dataField="edgeSubmissionId" dataFormat={this.formatQuoteClearedSubmissionData} headerAlign="left" dataAlign="center" width="120px">&nbsp;</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        )
    }
}
ClearedSubmissionListTable.propTypes = {
    getQuotePreClearedSubmission: PropTypes.func.isRequired
}


export default ClearedSubmissionListTable
